// extracted by mini-css-extract-plugin
export default {"container":"DS-z","title":"ES-z","link":"FS-z"};